import { Link } from 'react-router-dom'
import { useNews } from '../hooks/useNews'
import { formatDate, NEWS_CATEGORY_LABELS } from '../services/newsService'

const Updates = () => {
  const { news, loading, error } = useNews(4)

  if (loading) {
    return (
      <section className="updates" id="news">
        <div className="container">
          <h2 className="section-title">新着・更新</h2>
          <p style={{ textAlign: 'center', color: '#666' }}>読み込み中...</p>
        </div>
      </section>
    )
  }

  if (error || news.length === 0) {
    return (
      <section className="updates" id="news">
        <div className="container">
          <h2 className="section-title">新着・更新</h2>
          <p style={{ textAlign: 'center', color: '#666' }}>
            現在お知らせはありません
          </p>
        </div>
      </section>
    )
  }

  return (
    <section className="updates" id="news">
      <div className="container">
        <h2 className="section-title">新着・更新</h2>
        <div className="update-list">
          {news.map((item) => (
            <div key={item.id} className="update-item">
              <span className="update-date">{formatDate(item.publishDate)}</span>
              <span className="update-category">
                {NEWS_CATEGORY_LABELS[item.category]}
              </span>
              <Link to={`/news/${item.id}`} className="update-link">
                {item.title}
              </Link>
            </div>
          ))}
        </div>
        <div className="update-more">
          <a href="#news" className="btn btn-outline">
            一覧を見る
          </a>
        </div>
      </div>
    </section>
  )
}

export default Updates

